// Open/Close stocks off canvas (DOM, not jQuery)
export function stocksOffCanvas() {
    const btn = document.querySelector('.btn-stocks');
    if (!btn) return;

    const offCanvas = document.querySelector('.stocks-off-canvas');
    if (!offCanvas) return;
    
    const content = offCanvas.querySelector('.stocks-off-canvas-content');  
    const closeBtn = offCanvas.querySelector('.stocks-off-canvas-close');

    btn.addEventListener('click', (e) => {
        e.preventDefault();
        offCanvas.classList.add('active');
        content.classList.add('active');
    });

    closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        offCanvas.classList.remove('active');
        content.classList.remove('active');
    });

    // Close when clicking outside
    offCanvas.addEventListener('click', (e) => {
        if (e.target === offCanvas) {
            offCanvas.classList.remove('active');
            content.classList.remove('active');
        }
    });

    // Close with Escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            offCanvas.classList.remove('active');
            content.classList.remove('active');
        }
    });

    // Filter by format or color
    const formatSelect = content.querySelector('#stock-formatos');
    const colorSelect = content.querySelector('#stock-colores');

    formatSelect.addEventListener('change', (e) => {
        filterStocks(e.target.value, colorSelect.value);
    });
    
    colorSelect.addEventListener('change', (e) => {
        filterStocks(formatSelect.value, e.target.value);
    });
    
    function filterStocks(format, color) {
        const stocks = content.querySelectorAll('.table-stocks-tr');
        stocks.forEach((stock) => {
            const stockFormat = stock.getAttribute('data-formato');
            const stockColor = stock.getAttribute('data-color');

            stock.classList.remove('tr-hide');
            if (format && stockFormat !== format) stock.classList.add('tr-hide');
            if (color && stockColor !== color) stock.classList.add('tr-hide');
        });
    }   
}